export function cleanupName(input: string): string {
  return input.replace(/[<>&]/gim, function () {
    return " ";
  });
}
